import { IDriver } from "dataModels/contract";
import {
    FormMode,
    DATE_FORMAT,
    EntityType,
    getDriverFileInputConfig,
    IFileInputConfig,
    DsLayout,
} from "shared/constants";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-grid-system";
import moment from "moment";
import SimpleTable from "components/SimpleTable";
import { v4 as uuid } from "uuid";
import _ from "lodash";
import "views/contractView/styles/contractDataStyles.css"; //to be replaced with its own one
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { Output, Table } from "@ds/ds-snam/react";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import DriverInfo from "./driverInfo";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";

interface IDriverFormReview {
    formMode: FormMode;
    formData: IDriver;
}
const DriverFormReview: React.FC<IDriverFormReview> = (props): JSX.Element => {
    const { formMode, formData } = props;
    const { t } = useTranslation(["contract"]);

    const fileInputConfig: IFileInputConfig[] = getDriverFileInputConfig();
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });
    const tableColumns = (() => {
        //return ["Tipologia documento", "Nome File", "Data fine validità"]
        return t("drivers.driverForm.sections.review.fileTable.tableColumns", {
            ns: "contract",
            returnObjects: true,
        }) as string[];
    })();

    const tableRows = (filter: number): JSX.Element[] => {
        /**
         * let fileInputConfig = [
        { id: 0, step: 2, documentType: DocumentType.IDENTITY_CARD, title: "Carta di identità", expireRequired: true },
        { id: 1, step: 2, documentType: DocumentType.FISCAL_CODE, title: "Codice fiscale", expireRequired: true },
        { id: 2, step: 2, documentType: DocumentType.DRIVE_LICENCE, title: "Patente di guida", expireRequired: true },
        { id: 3, step: 2, documentType: DocumentType.PERSONAL_DATA, title: "Autorizzazione del trattamento dei dati personali", expireRequired: false },
        { id: 4, step: 3, documentType: DocumentType.QUALIFICATION_DRIVER, title: "CQC Carta Qualificazione Conducente", expireRequired: false },
        { id: 5, step: 3, documentType: DocumentType.ADR_DECLARATION, title: "Certificazione ADR", expireRequired: false },
        { id: 6, step: 3, documentType: DocumentType.FREQUENCY_CERTIFICATE, title: "Attestato di frequenza e idoneità del corso formativo erogato dall'operatore", expireRequired: false },
    ];
         */
        /*return [<tr key={uuid()}>
            <td>Carta d'identità</td>
            <td>{formData.documents[0].name}</td>
            <td>{moment.unix(formData.documents[0].expire!).format(DATE_FORMAT)}</td>
        </tr>,
        <tr key={uuid()}>
            <td>Codice fiscale</td>
            <td>{formData.documents[1].name}</td>
            <td>{moment.unix(formData.documents[1].expire!).format(DATE_FORMAT)}</td>
        </tr>,
        <tr key={uuid()}>
            <td>Patente di guida</td>
            <td>{formData.documents[2].name}</td>
            <td>{moment.unix(formData.documents[2].expire!).format(DATE_FORMAT)}</td>
        </tr>,
        <tr key={uuid()}>
            <td>Autorizzazione del trattamento dei dati personali</td>
            <td>{formData.documents[3].name}</td>
            <td></td>
        </tr>]*/

        return _.filter(fileInputConfig, { step: filter }).map(
            (fileConfigObj: IFileInputConfig) => {
                return (
                    <tr key={uuid()}>
                        <td>
                            {t(
                                "drivers.driverForm.sections.fileInput.title." +
                                    fileConfigObj.id
                            )}
                        </td>
                        <td>{formData.documents[fileConfigObj.id].name}</td>
                        <td>
                            {fileConfigObj.expireRequired
                                ? parseDateForDS(
                                      moment
                                          .unix(
                                              formData.documents[
                                                  fileConfigObj.id
                                              ].expire!
                                          )
                                          .format(DATE_FORMAT),
                                      IParseDateFormatType.DATE_FORMAT1
                                  )
                                : ""}
                        </td>
                    </tr>
                );
            }
        );
    };
    /*const certificationsTableRows = (): JSX.Element[] => {
        return [
            <tr key={uuid()}>
                <td>CQC Carta Qualificazione Conducente</td>
                <td>{formData.documents[4].name}</td>
                <td>{moment.unix(formData.documents[0].expire!).format(DATE_FORMAT)}</td>
            </tr>,
            <tr key={uuid()}>
                <td>Certificazione ADR</td>
                <td>{formData.documents[5].name}</td>
                <td>{moment.unix(formData.documents[1].expire!).format(DATE_FORMAT)}</td>
            </tr>,
            <tr key={uuid()}>
                <td>Attestato di frequenza e idoneità del corso formativo erogato dall'operatore</td>
                <td>{formData.documents[6].name}</td>
                <td>{moment.unix(formData.documents[2].expire!).format(DATE_FORMAT)}</td>
            </tr>
        ]
    }*/

        //da qui
             const getTableRows = (startIndex: number, endIndex: number): ITableRow[] => {
                let myRetArr: ITableRow[] = [];
                for (let i = startIndex; i < endIndex; i++) {
                    let tempObj: ITableRow = {
                        tableCells: [
                            { 
                                type: "text", 
                                text: t("drivers.driverForm.sections.fileInput.title." + fileInputConfig[i].id)
                            },
                            { 
                                type: "text", 
                                text: formData.documents[fileInputConfig[i].id].name,
                            },
                            { 
                                type: "text", 
                                text: fileInputConfig[i].expireRequired && formData.documents[fileInputConfig[i].id].expire!==null
                                    ? 
                                    parseDateForDS(
                                        moment
                                            .unix(formData.documents[fileInputConfig[i].id].expire!)
                                            .format(DATE_FORMAT),
                                        IParseDateFormatType.DATE_FORMAT1
                                    )

                                    : "",
                            }
                        ]
                    };
                    if(formData.documents[fileInputConfig[i].id].content!==""){
                        myRetArr.push(tempObj);
                    }
                }
                return myRetArr;
            };
            
            // Ora possiamo usare questa funzione per ottenere le righe della tabella:
            const getTableRowsCert = (): ITableRow[] => getTableRows(4, 7);
            const getTableRowsDoc = (): ITableRow[] => getTableRows(0, 4);
            // a qui

            
        const myTableConfigCert: ITableConfig = {
            ...getDSTableSharedElements(150),
            tableHeader: {
                
                tableCellsHeader: [
                    getTableCellsHeaderSimple(t("drivers.driverForm.sections.review.fileTable.tableColumns.0", {ns: "contract"}) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t("drivers.driverForm.sections.review.fileTable.tableColumns.1", {ns: "contract"}) as string,"col1","33%","left"),
                    getTableCellsHeaderSimple(t("drivers.driverForm.sections.review.fileTable.tableColumns.2", {ns: "contract"}) as string,"col1","33%","left"),
                   
                ]
            },
            tableRows: getTableRowsCert()
        };
    const myTableConfigDoc: ITableConfig = {
              ...getDSTableSharedElements(150),
              tableHeader: {
                  
                  tableCellsHeader: [
                    getTableCellsHeaderSimple(t("drivers.driverForm.sections.review.fileTable.tableColumns.0", {ns: "contract"}) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t("drivers.driverForm.sections.review.fileTable.tableColumns.1", {ns: "contract"}) as string,"col2","33%","left"),
                    getTableCellsHeaderSimple(t("drivers.driverForm.sections.review.fileTable.tableColumns.2", {ns: "contract"}) as string,"col3","33%","left"),
                  ]
              },
              tableRows: getTableRowsDoc()
          };


    return (
        <>
            {/*<Row style={{ marginBottom: "12px" }}>
            <Col>
                <div className="box">
                    <div className="boxTitle">
                        
                        {t('drivers.driverForm.sections.review.title.0')}

                    </div>
                    <div className="boxContent">
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.0')}
                                outputText={formData.firstName}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.2')}
                                outputText={formData.birthPlace}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.10')}
                                outputText={formData.documentType}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            

                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.1')}
                                outputText={formData.lastName}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.3')}
                                outputText={parseDateForDS(moment.unix(formData.birthDate).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.11')}
                                outputText={formData.documentNumber}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            

                        </div>
                        <div className="boxContentColumn" style={{height:'83%'}}>
                        <Output
                                outputTitle={"Identity Card"} //code card
                                outputText={formData.cardCode}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            </div>
                    </div>
                </div>
            </Col>
            <Col>
                <div className="box">
                    <div className="boxTitle">
                        
                        {t('drivers.driverForm.sections.review.title.1')}
                    </div>
                    <div className="boxContent">
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.4')}
                                outputText={formData.address}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.6')}
                                outputText={formData.city}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.8')}
                                outputText={formData.province}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            

                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.5')}
                                outputText={formData.streetNumber}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.7')}
                                outputText={formData.postalCode}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('drivers.driverForm.sections.dataInput.fields.9')}
                                outputText={formData.state}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            

                        </div>
                    </div>
                </div>
            </Col>
        </Row>*/}
            <DriverInfo formData={formData} />

            {formMode === FormMode.NEW && (
                <div
                    style={{
                        borderRadius: "12px",
                        background:
                            layoutMode === DsLayout.DARK_MODE
                                ? "#081C3E"
                                : "var(--Neutrali-0, #FFF)",
                        padding: "12px",
                        marginTop: "12px",
                    }}
                >
                    <p className="documentTableTitle--contract">
                        {/*Documenti*/}
                        {t(
                            "drivers.driverForm.sections.review.fileTable.title.0"
                        )}
                    </p>
                    {/*<SimpleTable columns={tableColumns} rows={tableRows(2)} />*/}
                        {
                            <Table 
                            tableConfig={myTableConfigDoc} 
                        />
                        }                    

                </div>
            )}

            {formMode === FormMode.NEW && (
                <div
                    style={{
                        borderRadius: "12px",
                        background:
                            layoutMode === DsLayout.DARK_MODE
                                ? "#081C3E"
                                : "var(--Neutrali-0, #FFF)",
                        padding: "12px",
                        marginTop: "12px",
                    }}
                >
                    <p className="documentTableTitle--contract">
                        {/*Certificazioni*/}
                        {t(
                            "drivers.driverForm.sections.review.fileTable.title.1"
                        )}
                    </p>
                    {/*<SimpleTable columns={tableColumns} rows={tableRows(3)} />*/}
                    {
                            <Table 
                            tableConfig={myTableConfigCert} 
                        />
                        } 
                </div>
            )}
        </>
    );
};
export default DriverFormReview;
